import I18nModule, { I18n }from "i18n-js";

export enum Locale {
  ZH_TW = "zh_tw",
  ZH_HK = "zh_hk",
  EN = "en",
  JA = "ja",
  CN = "cn",
  EN_AU = "en_au",
}

const getHeaderLocale = (locale: Locale) => {
  switch (locale) {
    case 'zh_tw':
      return 'zh_tw';
    case 'zh_hk':
      return 'zh_hk';
    case 'en':
      return 'en';
    case 'cn':
      return 'zh_cn';
    case 'en_au':
      return 'au';
    case 'ja':
      return 'ja';
    default:
      return 'zh_tw';
  }
}

const i18n = new I18n();

i18n.defaultLocale = "zh_tw";
i18n.enableFallback = true;

const setLocale = (locale: Locale) => {
  i18n.locale = locale;
};

const getLocale = (): Locale => {
  return i18n.locale as Locale;
};

const getLocaleKebab = (): string => {
  return i18n.locale.replace("_", "-");
};

function translation(label: string, ...args: I18nModule.TranslateOptions[]) {
  return i18n.t(label, ...args);
}

export { translation, setLocale, getLocale, getLocaleKebab, getHeaderLocale };
